<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="设备名称" prop="name">
                <el-input
                clearable
                disabled v-model="form.name"
             
                maxlength="20"
                ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="在线状态" prop="onlineStatus">
              
              <el-input
                clearable
                disabled v-model="form.onlineStatusValue"
             
                maxlength="100"
              ></el-input> 
             
            </el-form-item>
          </el-col>
         
          <el-col :span="8">
            <el-form-item label="绑定老人" prop="elderlyName">
              
              <el-input
                clearable
                disabled v-model="form.elderlyName"
              
                maxlength="100"
              ></el-input> 
             
            </el-form-item>
          </el-col>
        </el-row>
        </el-form>
       <div>
        <player ref="player" :videoUrl="form.cameraUrl" fluent autoplay hasAudio  @screenshot="shot"
        live
            />
       </div>
        
      </div>
    </div>
  </template>
  <script>
 
  import {
    getSmartDeviceDetail
  } from  '@/api/nursingHome/elderDevice';
  import player from '../components/jessibuca.vue';
  export default {
    components: {player},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      nursinghomeName: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        activeFlag: true,
        projectList: [],
        activeName: 'first',
        form: {
          onlineStatusValue: '',
          name: '',
          // birthday: '123',
          elderlyName: '',
          currentPower:'',
          cameraUrl:''
        },
        formRules: {
        
        },
        matetialList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      shot(e) {
      // console.log(e)
      // send({code:'image',data:e})
      var base64ToBlob = function (code) {
        let parts = code.split(';base64,');
        let contentType = parts[0].split(':')[1];
        let raw = window.atob(parts[1]);
        let rawLength = raw.length;
        let uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
          type: contentType
        });
      };
      let aLink = document.createElement('a');
      let blob = base64ToBlob(e); //new Blob([content]);
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = '截图';
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
    },
      initData() {
        this.form.name = this.row.name
        this.form.onlineStatusValue = this.row.onlineStatusValue
        this.form.elderlyName = this.row.elderlyName
        getSmartDeviceDetail({id:this.row.id}).then((res)=>{
          this.form.cameraUrl= res.data.cameraUrl
        })
      },
      getInfo(){

      },
      handleClick() {
        if (this.activeName === 'first') {
          this.$refs.baseInfoRef.initData();
        }
        if (this.activeName === 'second') {
          this.$refs.FamilyInfoRef.initData();
        }
        if (this.activeName === 'third') {
          this.$refs.HealthInfoRef.initData();
          // this.activeName = 'fourth'
        }
        if (this.activeName === 'fourth') {
          this.$refs.MedicalTestInfoRef.initData();
          // this.activeName = 'five'
        }
        if (this.activeName === 'five') {
          this.$refs.CateringBedsInfoRef.initData();
        }
        console.log(this.activeName);
      },
     
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
  